const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export const printTrenitaliaTicket = (client, moves) => {
  const now = new Date();
  const dateStr = `${now.toLocaleDateString("fr-FR")} ${now.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`;
  const rows = moves.map((m) => `
    <div class="move">
      <div class="row"><span>${new Date(m.created_at).toLocaleDateString("fr-FR")}</span><span>${m.delta > 0 ? "+" : ""}${m.delta} pts</span></div>
      ${m.note ? `<div class="note">${esc(m.note)}</div>` : ""}
      <div class="row small"><span>Solde</span><span>${m.balance} pts</span></div>
    </div>`).join("");

  const w = window.open("", "_blank");
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8">
    <title>Trenitalia - ${esc(client.first_name)} ${esc(client.last_name)}</title>
    <style>
      @page { size: 80mm auto; margin: 0; }
      * { color: #000 !important; font-weight: bold !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
      body { font-family: 'Courier New', Courier, monospace; width: 80mm; margin: 0 auto; padding: 5mm; font-size: 13px; line-height: 1.3; background: #fff; }
      .logo { text-align: center; margin-bottom: 8px; }
      .logo img { max-width: 50mm; height: auto; filter: grayscale(100%) contrast(200%) brightness(0.9); }
      .title { text-align: center; font-size: 16px; font-weight: 900 !important; margin: 6px 0; }
      .client { text-align: center; font-size: 15px; font-weight: 900 !important; margin: 8px 0; padding: 5px; border: 3px solid #000; }
      .row { display: flex; justify-content: space-between; font-size: 12px; margin: 2px 0; }
      .small { font-size: 11px; }
      .note { font-size: 11px; font-style: italic; }
      .separator { border-top: 3px dashed #000; margin: 8px 0; }
      .move { border-top: 2px dashed #000; padding: 4px 0; }
      .amount { text-align: center; font-size: 20px; font-weight: 900 !important; margin: 8px 0; padding: 10px; border: 4px solid #000; }
      .footer { text-align: center; font-size: 11px; margin-top: 12px; }
      @media print { body { margin: 0; padding: 3mm; } }
    </style></head><body>
    <div class="logo"><img src="/logo-sakura.png" alt="Pressing Sakura" /></div>
    <div class="title">AVOIR TRENITALIA</div>
    <div class="client">${esc(client.first_name)} ${esc(client.last_name)}</div>
    <div class="row"><span>Édité le :</span><span>${dateStr}</span></div>
    <div class="amount">SOLDE : ${client.points} PTS</div>
    <div class="separator"></div>
    <div style="text-align:center; margin-bottom:5px;">HISTORIQUE</div>
    ${rows || '<div style="text-align:center">Aucun mouvement</div>'}
    <div class="separator"></div>
    <div class="footer">Merci de votre confiance !<br>Pressing Sakura</div>
    <script>window.onload = function() { window.print(); }</script>
    </body></html>`);
  w.document.close();
};

export const printTrenitaliaSummary = (clients) => {
  const total = clients.reduce((s, c) => s + c.points, 0);
  const rows = clients.map((c, i) => `<tr><td>${i + 1}</td><td>${esc(c.last_name.toUpperCase())}</td><td>${esc(c.first_name)}</td><td class="r">${c.points} pts</td></tr>`).join("");
  const now = new Date();
  const w = window.open("", "_blank");
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Trenitalia - Récapitulatif</title>
    <style>
      @page { size: A4; margin: 15mm; }
      body { font-family: Arial, sans-serif; color: #000; font-size: 12px; }
      .head { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #000; padding-bottom: 8px; }
      .head img { height: 50px; }
      h1 { font-size: 20px; margin: 0; }
      table { width: 100%; border-collapse: collapse; margin-top: 12px; }
      th, td { border: 1px solid #000; padding: 5px 8px; text-align: left; }
      th { background: #eee; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .r { text-align: right; }
      tfoot td { font-weight: bold; font-size: 14px; }
    </style></head><body>
    <div class="head"><img src="/logo-sakura.png" alt="Pressing Sakura" />
      <div style="text-align:right"><h1>AVOIRS TRENITALIA</h1><div>Édité le ${now.toLocaleDateString("fr-FR")} à ${now.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}</div></div></div>
    <table><thead><tr><th>#</th><th>Nom</th><th>Prénom</th><th class="r">Points</th></tr></thead>
      <tbody>${rows || '<tr><td colspan="4">Aucun client</td></tr>'}</tbody>
      <tfoot><tr><td colspan="3">TOTAL — ${clients.length} client(s)</td><td class="r">${total} pts</td></tr></tfoot></table>
    <script>window.onload = function() { window.print(); }</script>
    </body></html>`);
  w.document.close();
};
